import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let VirtualList = class VirtualList extends Vue {
    isPagination;
    listData;
    itemSize;
    spacing; // 下边距，左右比边距
    screenWidth;
    screenHeight; // 可视区域高度
    // screenHeight = 0;
    // 偏移量
    startOffset = 0;
    // 起始索引
    start = 0;
    // 结束索引
    end = 0;
    lineCardNum = 1;
    boxWidth = 0; // 可视区域实际宽度
    isGetData = true;
    // 列表总高度
    get listHeight() {
        let curHeight = (this.listData.length / this.lineCardNum) * (this.itemSize.height + this.spacing[0]) - 114;
        return curHeight > this.itemSize.height ? curHeight : 500;
    }
    // 最小高度
    get minHeight() {
        return this.screenHeight - 114;
    }
    // 可显示的列表行数
    get visibleCount() {
        return Math.ceil(this.screenHeight / (this.itemSize.height + this.spacing[0])) + 1;
    }
    // 偏移量对应的style
    get getTransform() {
        return `translate3d(0,${this.startOffset}px,0)`; //
    }
    // 获取真实显示列表数据
    get visibleData() {
        return this.listData.slice(this.start, Math.min(this.end, this.listData.length));
    }
    // 左右边距
    get marginLeftRight() {
        return this.spacing[1] / 2;
    }
    changeWidth() {
        this.init();
    }
    changeList() {
        this.isGetData = true;
        if (!this.isPagination) {
            this.resetScroll(); // 翻页滚动条置顶
        }
    }
    mounted() {
        window.addEventListener('resize', this.init, true);
    }
    getItem(i, v) {
        return { ...i, index: v };
    }
    resetScroll() {
        this.$refs.list.scrollTop = 0;
    }
    getWidth() {
        const margin = this.spacing[1];
        const itemWidth = this.itemSize.width;
        const curWidth = this.screenWidth / (itemWidth + margin);
        this.boxWidth = (itemWidth + margin) * Math.round(curWidth) + 10;
        this.lineCardNum = Math.round(curWidth);
    }
    init() {
        this.getWidth();
        this.start = 0;
        this.end = this.start + this.visibleCount * this.lineCardNum;
    }
    scrollEvent() {
        // 当前滚动位置
        let scrollTop = this.$refs.list.scrollTop;
        this.$emit('scrollTop', scrollTop);
        let currentOffsetHeight = this.$refs.list.scrollHeight;
        let currentClientHeight = this.$refs.list.clientHeight;
        if (Math.round(scrollTop + currentClientHeight) >= currentOffsetHeight - 50) {
            return;
        }
        // 此时的开始索引
        this.start = Math.floor(scrollTop / (this.itemSize.height + this.spacing[0])) * this.lineCardNum;
        // 此时的结束索引
        this.end = this.start + this.visibleCount * this.lineCardNum;
        // 此时的偏移量
        this.startOffset = scrollTop - (scrollTop % (this.itemSize.height + this.spacing[0]));
        if (Math.round(scrollTop + currentClientHeight) >= currentOffsetHeight - 50 && !this.isPagination && this.isGetData) {
            this.isGetData = false;
            this.$emit('getMoreData');
        }
    }
    beforeDestroy() {
        window.removeEventListener('resize', this.init, true);
    }
};
__decorate([
    Prop({ default: false })
], VirtualList.prototype, "isPagination", void 0);
__decorate([
    Prop({ default: [] })
], VirtualList.prototype, "listData", void 0);
__decorate([
    Prop({
        default: {
            height: 200,
            width: 0,
        },
    })
], VirtualList.prototype, "itemSize", void 0);
__decorate([
    Prop({ default: [20, 20] })
], VirtualList.prototype, "spacing", void 0);
__decorate([
    Prop({ default: 0 })
], VirtualList.prototype, "screenWidth", void 0);
__decorate([
    Prop({ default: 500 })
], VirtualList.prototype, "screenHeight", void 0);
__decorate([
    Watch('screenWidth')
], VirtualList.prototype, "changeWidth", null);
__decorate([
    Watch('listData')
], VirtualList.prototype, "changeList", null);
VirtualList = __decorate([
    Component({
        name: 'VirtualList',
        i18n: {
            messages: {
                en: {
                    nodata: 'No Data',
                },
                zh: {
                    nodata: '暂无数据',
                },
            },
        },
    })
], VirtualList);
export default VirtualList;
